/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable global-require */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

import Docxtemplater from "docxtemplater";
import FileSaver from "file-saver";
import JSZip from "jszip";
import PizZip from "pizzip";
import { read, utils, write, writeFileXLSX } from "xlsx";

/* eslint-disable no-undef */
class CustomerApi {
  async getCustomers(
    accessToken,
    query = "",
    sort = null,
    source = "all",
    campaign = "all",
    callTrack = "all",
    newCallTrack = "all",
    callTrackRelaunch = "all",
    progress = "all",
    endSessions = "all",
    relaunch = "all",
    profession = "all",
    limit = 25,
    page = 0,
    relaunchMode = false,
    isSearching = true,
    region = "all",
    city = "all",
    status = "all",
  ) {
    const urlCustomers = `${process.env.REACT_APP_API_URL}/api/customers`;
    const values = {};
    values.query = query;
    values.sort = sort;
    values.source = source;
    values.campaign = campaign;
    values.callTrack = callTrack;
    values.newCallTrack = newCallTrack;
    values.callTrackRelaunch = callTrackRelaunch;
    values.progress = progress;
    values.endSessions = endSessions;
    values.relaunch = relaunch;
    values.profession = profession;
    values.region = region;
    values.city = city;
    values.status = status;
    values.limit = limit;
    values.page = page;
    values.relaunchMode = relaunchMode;
    values.isSearching = isSearching;
    const resp = await fetch(urlCustomers, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  // Abdo essaidi : méthode checkDuplicateInOtherTenant

  async checkDuplicateInOtherTenant(rpps, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/check-duplicate/${rpps}`;

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // Abdo essaidi : Vérifier si la réponse est OK avant de parser
    if (!resp.ok) {
      const errorText = await resp.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch (e) {
        throw new Error(`HTTP ${resp.status}: ${errorText || resp.statusText}`);
      }
      throw new Error(errorData.message || `HTTP ${resp.status}`);
    }

    const json = await resp.json();
    return Promise.resolve(json);
  }

  // Abdo essaid : Nouvelle version 1.3 de la fonction checkDuplicateInAllTenants

  /**
   * Vérifie si un apprenant existe dans tous les autres tenants
   * @param {string} rpps - Numéro RPPS
   * @param {string|number} customerId - ID du client courant (pour vérifier s'il est apprenant)
   * @param {string} accessToken - Token JWT
   */
  async checkDuplicateInAllTenants(rpps, customerId, accessToken) {
    // Ajout du paramètre customer_id dans l'URL
    const url = `${process.env.REACT_APP_API_URL}/api/customers/check-all-duplicates/${rpps}?customer_id=${customerId}`;

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!resp.ok) {
      const errorText = await resp.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch (e) {
        throw new Error(`HTTP ${resp.status}: ${errorText || resp.statusText}`);
      }
      throw new Error(errorData.message || `HTTP ${resp.status}`);
    }

    const json = await resp.json();
    return Promise.resolve(json);
  }

  async getCustomersInfos(
    accessToken,
    query = "",
    sort = null,
    source = "all",
    campaign = "all",
    callTrack = "all",
    newCallTrack = "all",
    callTrackRelaunch = "all",
    progress = "all",
    endSessions = "all",
    relaunch = "all",
    profession = "all",
    limit = 25,
    page = 0,
    relaunchMode = false,
    isSearching = true,
    region = "all",
    city = "all",
    status = "all",
  ) {
    const urlCustomers = `${process.env.REACT_APP_API_URL}/api/customersInfos`;
    const values = {};
    values.query = query;
    values.sort = sort;
    values.source = source;
    values.campaign = campaign;
    values.callTrack = callTrack;
    values.newCallTrack = newCallTrack;
    values.callTrackRelaunch = callTrackRelaunch;
    values.progress = progress;
    values.endSessions = endSessions;
    values.relaunch = relaunch;
    values.profession = profession;
    values.region = region;
    values.city = city;
    values.status = status;
    values.limit = limit;
    values.page = page;
    values.relaunchMode = relaunchMode;
    values.isSearching = isSearching;
    const resp = await fetch(urlCustomers, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomersAnalyse(accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customersAnalyse`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({}),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomersAnalyseFiltered(accessToken, department = null, profession = null) {
    const url = `${process.env.REACT_APP_API_URL}/api/customersAnalyseFiltered`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ department, profession }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomer(idCustomer, accessToken) {
    const urlCustomer = `${process.env.REACT_APP_API_URL}/api/customers/${idCustomer}`;

    const resp = await fetch(urlCustomer, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomerRelationScore(customerId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/${customerId}/relation-score`;

    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getRelationScores(ids, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/relation-scores`;

    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ ids }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  /* ===================== Réseau pro (relations entre apprenants) ===================== */

  async getCustomerRelations(customerId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/relations/list/${customerId}`;
    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const json = await resp.json();
    return Promise.resolve(json.data || []);
  }

  async getRelationCandidates(query, customerId, accessToken) {
    const params = new URLSearchParams({
      query: query || "",
      customerId: customerId || "",
    });
    const url = `${process.env.REACT_APP_API_URL}/api/customers/relations/candidates?${params.toString()}`;
    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const json = await resp.json();
    return Promise.resolve(json.data || []);
  }

  async addCustomerRelation(customerId, relatedCustomerId, type, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/relations/add`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ customerId, relatedCustomerId, type }),
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async deleteCustomerRelation(id, customerId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/relations/delete`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ id, customerId }),
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async getDisplayPasswordsCustomer(accessToken) {
    const urlCustomer = `${process.env.REACT_APP_API_URL}/api/customers/password/getDisplayPasswordsCustomer`;

    const resp = await fetch(urlCustomer, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  // async getCustomerLogs(idCustomer, accessToken) {
  //   const urlCustomer = `${process.env.REACT_APP_API_URL}/api/customers/logs/${idCustomer}`;

  //   const resp = await fetch(urlCustomer, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   });

  //   const json = await resp.json();

  //   return Promise.resolve(json.data);
  // }

  async getCustomerLogs(
    customerId,
    sort = null,
    user,
    category,
    type,
    limit = 25,
    page = 0,
    accessToken,
  ) {
    const urlLogs = `${process.env.REACT_APP_API_URL}/api/customers/logs`;
    const values = {};
    values.sort = sort;
    values.user = user;
    values.category = category;
    values.type = type;
    values.customerId = customerId;
    values.limit = limit;
    values.page = page;
    const resp = await fetch(urlLogs, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomerLogsInfos(idCustomer, accessToken) {
    const urlCustomer = `${process.env.REACT_APP_API_URL}/api/customers/logs/infos/${idCustomer}`;

    const resp = await fetch(urlCustomer, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCommentsCommercialUser(idCustomer, userId, accessToken) {
    const urlCustomer = `${process.env.REACT_APP_API_URL}/api/customers/get-comments-commercial-user`;
    const values = {};
    values.customerId = idCustomer;
    values.userId = userId;
    const resp = await fetch(urlCustomer, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomerCampagne(idCustomer, accessToken) {
    const urlCustomer = `${process.env.REACT_APP_API_URL}/api/campagne/${idCustomer}`;

    const resp = await fetch(urlCustomer, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomersCampagne(
    accessToken,
    query = null,
    sort = null,
    source = "all",
    campaign = "all",
    callTrack = "all",
    newCallTrack = "all",
    callTrackRelaunch = "all",
    progress = "all",
    endSessions = "all",
    relaunch = "all",
    profession = "all",
    limit = 25,
    page = 0,
    relaunchMode = false,
    isSearching = true,
  ) {
    const urlCampagne = `${process.env.REACT_APP_API_URL}/api/campagne`;
    const values = {};
    values.query = query;
    values.sort = sort;
    values.source = source;
    values.campaign = campaign;
    values.callTrack = callTrack;
    values.newCallTrack = newCallTrack;
    values.callTrackRelaunch = callTrackRelaunch;
    values.progress = progress;
    values.endSessions = endSessions;
    values.relaunch = relaunch;
    values.profession = profession;
    values.limit = limit;
    values.page = page;
    values.relaunchMode = relaunchMode;
    values.isSearching = isSearching;

    const resp = await fetch(urlCampagne, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async updateCustomer(customerId, values, accessToken) {
    const URL_UPDATE = `${process.env.REACT_APP_API_URL}/api/customers/update-customer`;
    values.id = customerId;
    const resp = await fetch(URL_UPDATE, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async updateByRpps(customerId, rpps, accessToken) {
    const URL_UPDATE = `${process.env.REACT_APP_API_URL}/api/customers/update-by-rpps`;
    const values = { id: customerId, adeliRpps: rpps };
    const resp = await fetch(URL_UPDATE, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  // Abdo essaidi : modification de la fonction updateAllByRpps
  async updateAllByRpps(accessToken) {
    const URL_UPDATE = `${process.env.REACT_APP_API_URL}/api/customers/update-all-by-rpps`;
    
    // Abdo essaidi : On envoie un POST vide, l'authentification se fait via le token
    const resp = await fetch(URL_UPDATE, {
      method: "POST",
      body: JSON.stringify({}), 
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();
    return json;
  }
  // Abdo essaidi : modification de la fonction getRppsUpdateCount
  async getRppsUpdateCount(accessToken) {
    // Abdo essaidi : On utilise votre route exacte '/api/customers/update-all-by-rpps'
    const url = `${process.env.REACT_APP_API_URL}/api/customers/update-all-by-rpps`; 
    
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ action: 'count' }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (resp.ok) {
      return await resp.json();
    }
    
    // Abdo essaidi : On récupère le message d'erreur du serveur si possible
    const errorBody = await resp.json().catch(() => ({}));
    throw new Error(errorBody.message || "Erreur lors du comptage (404 ou 500)");
  }
  // Abdo essaidi : modification de la fonction processRppsBatch
  async processRppsBatch(accessToken, limit, offset) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/update-all-by-rpps`;
    
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ 
        action: 'process', // Abdo essaidi : Action corrigée pour correspondre au backend
        limit: limit,
        offset: offset
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!resp.ok) {
      throw new Error(`HTTP ${resp.status}`);
    }

    return await resp.json();
  }

  async createCustomer(values, accessToken) {
    const URL_CREATE = `${process.env.REACT_APP_API_URL}/api/customers/create-customer`;
    const resp = await fetch(URL_CREATE, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async addCommentRelance(customerId, userId, values, accessToken) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/add-comment-relance`;
    values.customerId = customerId;
    values.userId = userId;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async addCommentRelanceSpecial(
    customerId,
    userId,
    comment,
    qualification,
    accessToken,
  ) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/add-comment-relance-special`;
    const values = {};
    values.customerId = customerId;
    values.userId = userId;
    values.qualification = qualification;
    values.comment = comment;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async addCommentCommercial(customerId, userId, values, accessToken) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/add-comment-commercial`;
    values.customerId = customerId;
    values.userId = userId;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async saveCommentCommercialId(
    commentId,
    customerId,
    campaignId,
    userId,
    accessToken,
  ) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/save-comment-commercial-id`;
    const values = {};
    values.customerId = customerId;
    values.userId = userId;
    values.commentId = commentId;
    values.campaignId = campaignId;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async setCustomerTreated(customerId, campaignId, userId, accessToken) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/set-customer-treated`;
    const values = {};
    values.customerId = customerId;
    values.userId = userId;
    values.campaignId = campaignId;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async setCustomerUntreated(customerId, campaignId, userId, accessToken) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/set-customer-untreated`;
    const values = {};
    values.customerId = customerId;
    values.userId = userId;
    values.campaignId = campaignId;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async saveCommentCommercialIdReinj(
    commentId,
    customerId,
    campaignId,
    userId,
    accessToken,
  ) {
    const URL_ADD = `${process.env.REACT_APP_API_URL}/api/customers/save-comment-commercial-id-reinj`;
    const values = {};
    values.customerId = customerId;
    values.userId = userId;
    values.commentId = commentId;
    values.campaignId = campaignId;
    const resp = await fetch(URL_ADD, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async deleteCustomerFormation(id, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/customers/delete-customer-formation`;
    const resp = await fetch(URL_DELETE, {
      method: "POST",
      body: JSON.stringify({ id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async deleteCommentRelance(id, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/customers/delete-comment-relance`;
    const resp = await fetch(URL_DELETE, {
      method: "POST",
      body: JSON.stringify({ id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async deleteCommentCommercial(id, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/customers/delete-comment-commercial`;
    const resp = await fetch(URL_DELETE, {
      method: "POST",
      body: JSON.stringify({ id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async deleteCustomer(customerId, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/customers/delete-customer`;
    const resp = await fetch(URL_DELETE, {
      method: "POST",
      body: JSON.stringify({ id: customerId }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async sendDoc(customerId, sourceId, values, accessToken) {
    const URL_CREATE_DOC = `${process.env.REACT_APP_API_URL}/api/customers/create-document`;
    const data = new FormData();
    values.forEach((value, index) => {
      data.append(`asset${index}`, value.file);
      data.append(`name${index}`, value.name);
      data.append(`type${index}`, value.type);
    });
    data.append("sourceId", sourceId);
    data.append("customerId", customerId);
    const resp = await fetch(URL_CREATE_DOC, {
      method: "POST",
      body: data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async deleteDoc(data, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/customers/delete-document`;
    const resp = await fetch(URL_DELETE, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async assignCampaign(userAssigned, selectedCustomers, accessToken) {
    const URL_ASSIGN = `${process.env.REACT_APP_API_URL}/api/customers/assign-campaign`;
    const values = {};
    values.userAssigned = userAssigned;
    values.selectedCustomers = selectedCustomers;
    const resp = await fetch(URL_ASSIGN, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async assignRelance(userAssigned, selectedCustomers, accessToken) {
    const URL_ASSIGN = `${process.env.REACT_APP_API_URL}/api/customers/assign-relance`;
    const values = {};
    values.userAssigned = userAssigned;
    values.selectedCustomers = selectedCustomers;
    const resp = await fetch(URL_ASSIGN, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return json;
  }

  async getProspect(
    accessToken,
    query = null,
    sort = null,
    source = null,
    campaign = null,
    callTrack = null,
    newCallTrack = null,
    callTrackRelaunch = null,
    progress = null,
    endSessions = null,
    relaunch = null,
    profession = null,
    limit = 25,
    page = 0,
    relaunchMode = false,
  ) {
    const urlCustomers = `${process.env.REACT_APP_API_URL}/api/customers/prospect`;
    const values = {};
    values.query = query;
    values.sort = sort;
    values.source = source;
    values.campaign = campaign;
    values.callTrack = callTrack;
    values.newCallTrack = newCallTrack;
    values.callTrackRelaunch = callTrackRelaunch;
    values.progress = progress;
    values.endSessions = endSessions;
    values.relaunch = relaunch;
    values.profession = profession;
    values.limit = limit;
    values.page = page;
    values.relaunchMode = relaunchMode;
    const resp = await fetch(urlCustomers, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getLogs(
    accessToken,
    customerId,
    sort = null,
    user,
    category,
    type,
    limit = 25,
    page = 0,
  ) {
    const urlLogs = `${process.env.REACT_APP_API_URL}/api/customers/logs/filtered`;
    const values = {};
    values.sort = sort;
    values.user = user;
    values.category = category;
    values.type = type;
    values.customerId = customerId;
    values.limit = limit;
    values.page = page;
    const resp = await fetch(urlLogs, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async sendAgreement(id, accessToken, engine) {
    const URL = `${process.env.REACT_APP_API_URL}/api/agreements/build`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ learnerSessionId: id, engine }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    console.clear();
    return json;
  }

  async downloadAgrement(id, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/agreements/download`;
    const token = accessToken;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ learnerSessionId: id }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (!response.ok) {
        return data;
      }

      const binaryString = atob(data.file);

      // Conversion Base64 en octets (ArrayBuffer)
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Décompression du contenu Base64 avec PizZip
      const zip = new PizZip(bytes);

      // Récupération du contenu du document Word
      const content = zip.file("word/document.xml").asText();

      // Utilisation de docxtemplater pour générer le fichier .docx
      const doc = new Docxtemplater();
      doc.loadZip(zip);
      doc.setData({
        /* Vos données à remplir dans le document */
      });
      try {
        doc.render();
      } catch (error) {
        const e = {
          message: error.message,
          name: error.name,
          stack: error.stack,
          properties: error.properties,
        };
        console.log(JSON.stringify({ error: e }));
        // Gestion des erreurs ici
        throw error;
      }

      // Génération du document final
      const output = doc.getZip().generate({ type: "uint8array" });

      // Création d'un objet Blob à partir du contenu généré
      const blob = new Blob([output], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // Utilisation de FileSaver.js pour télécharger le fichier
      FileSaver.saveAs(blob, data.path);

      console.clear();
      return data;
    } catch (error) {
      // Gérer les erreurs ici
      console.error(error);
      throw error;
    }
  }

  async downloadMultipleAgreements(ids, sessionId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/agreements/download`;
    const zip = new JSZip();
    const results = [];

    try {
      for (const id of ids) {
        try {
          const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({ learnerSessionId: id }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Failed to download agreement for ID: ${id}`);
          }

          const data = await response.json();
          const binaryString = atob(data.file);

          // Conversion Base64 en octets (ArrayBuffer)
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          // Décompression du contenu Base64 avec PizZip
          const docZip = new PizZip(bytes);

          // Utilisation de docxtemplater pour générer le fichier .docx
          const doc = new Docxtemplater();
          doc.loadZip(docZip);
          doc.setData({
            /* Vos données à remplir dans le document */
          });
          doc.render();

          // Génération du document final
          const output = doc.getZip().generate({ type: "uint8array" });

          // Ajout du fichier .docx au ZIP avec un nom unique
          zip.file(`${data.path}`, output);

          // Enregistrement du succès
          results.push({ id, status: "success" });
        } catch (error) {
          console.error(`Error processing ID: ${id}`, error);
          // Enregistrement de l'échec
          results.push({ id, status: "error", message: error.message });
        }
      }

      // Génération du fichier ZIP et téléchargement s'il y a des fichiers réussis
      if (results.some((result) => result.status === "success")) {
        const zipBlob = await zip.generateAsync({ type: "blob" });
        FileSaver.saveAs(zipBlob, `conventions-session-${sessionId}.zip`);
      }

      console.clear();
    } catch (error) {
      console.error("Error during the batch download process:", error);
      results.push({ globalStatus: "error", message: error.message });
    }

    return results;
  }

  async downloadCertificate(id, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/download`;
    const token = accessToken;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ learnerSessionId: id }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (!response.ok) {
        return data;
      }

      const binaryString = atob(data.file);

      // Conversion Base64 en octets (ArrayBuffer)
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Décompression du contenu Base64 avec PizZip
      const zip = new PizZip(bytes);

      // Récupération du contenu du document Word
      const content = zip.file("word/document.xml").asText();

      // Utilisation de docxtemplater pour générer le fichier .docx
      const doc = new Docxtemplater();
      doc.loadZip(zip);
      doc.setData({
        /* Vos données à remplir dans le document */
      });
      try {
        doc.render();
      } catch (error) {
        const e = {
          message: error.message,
          name: error.name,
          stack: error.stack,
          properties: error.properties,
        };
        console.log(JSON.stringify({ error: e }));
        // Gestion des erreurs ici
        throw error;
      }

      // Génération du document final
      const output = doc.getZip().generate({ type: "uint8array" });

      // Création d'un objet Blob à partir du contenu généré
      const blob = new Blob([output], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // Utilisation de FileSaver.js pour télécharger le fichier
      FileSaver.saveAs(blob, data.path);

      console.clear();
      return data;
    } catch (error) {
      // Gérer les erreurs ici
      console.error(error);
      throw error;
    }
  }

  async downloadMultipleCertificates(ids, sessionId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/download`;
    const zip = new JSZip();

    for (const id of ids) {
      try {
        const response = await fetch(url, {
          method: "POST",
          body: JSON.stringify({ learnerSessionId: id }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const data = await response.json();
        if (!response.ok) {
          console.error(`Erreur lors du téléchargement pour l'ID ${id}:`, data);
          // eslint-disable-next-line no-continue
          continue; // Passe au prochain ID si une erreur est rencontrée
        }

        const binaryString = atob(data.file);

        // Conversion Base64 en octets (ArrayBuffer)
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        // Décompression du contenu Base64 avec PizZip
        const docZip = new PizZip(bytes);

        // Utilisation de docxtemplater pour générer le fichier .docx
        const doc = new Docxtemplater();
        doc.loadZip(docZip);
        doc.setData({
          /* Insérez vos données ici si nécessaire */
        });
        try {
          doc.render();
        } catch (error) {
          console.error(
            `Erreur lors de la génération du document pour l'ID ${id}:`,
            error,
          );
          // eslint-disable-next-line no-continue
          continue; // Passe au prochain ID si une erreur est rencontrée
        }

        // Génération du document final
        const output = doc.getZip().generate({ type: "uint8array" });

        // Ajout du document au fichier ZIP avec un nom unique pour chaque ID
        zip.file(`certificate_${id}.docx`, output);
      } catch (error) {
        console.error(`Erreur lors du traitement de l'ID ${id}:`, error);
      }
    }

    // Génération du fichier ZIP et téléchargement
    try {
      const zipContent = await zip.generateAsync({ type: "blob" });
      FileSaver.saveAs(zipContent, "certificates.zip");
    } catch (error) {
      console.error("Erreur lors de la création du fichier ZIP:", error);
    }
  }

  async downloadSwarnStatement(id, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/swarn-statements/download`;
    const token = accessToken;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ learnerSessionId: id }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (!response.ok) {
        return data;
      }

      const binaryString = atob(data.file);

      // Conversion Base64 en octets (ArrayBuffer)
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Décompression du contenu Base64 avec PizZip
      const zip = new PizZip(bytes);

      // Récupération du contenu du document Word
      const content = zip.file("word/document.xml").asText();

      // Utilisation de docxtemplater pour générer le fichier .docx
      const doc = new Docxtemplater();
      doc.loadZip(zip);
      doc.setData({
        /* Vos données à remplir dans le document */
      });
      try {
        doc.render();
      } catch (error) {
        const e = {
          message: error.message,
          name: error.name,
          stack: error.stack,
          properties: error.properties,
        };
        console.log(JSON.stringify({ error: e }));
        // Gestion des erreurs ici
        throw error;
      }

      // Génération du document final
      const output = doc.getZip().generate({ type: "uint8array" });

      // Création d'un objet Blob à partir du contenu généré
      const blob = new Blob([output], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // Utilisation de FileSaver.js pour télécharger le fichier
      FileSaver.saveAs(blob, data.path);

      console.clear();
      return data;
    } catch (error) {
      // Gérer les erreurs ici
      console.error(error);
      throw error;
    }
  }

  async downloadMultipleSwarnStatements(ids, sessionId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/swarn-statements/download`;
    const zip = new JSZip();
    const results = [];

    try {
      for (const id of ids) {
        try {
          const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({ learnerSessionId: id }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Failed to download document for ID: ${id}`);
          }

          const data = await response.json();
          const binaryString = atob(data.file);

          // Conversion Base64 en octets (ArrayBuffer)
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          // Décompression du contenu Base64 avec PizZip
          const docZip = new PizZip(bytes);

          // Utilisation de docxtemplater pour générer le fichier .docx
          const doc = new Docxtemplater();
          doc.loadZip(docZip);
          doc.setData({
            /* Vos données à remplir dans le document */
          });
          doc.render();

          // Génération du document final
          const output = doc.getZip().generate({ type: "uint8array" });

          // Ajout du fichier .docx au ZIP avec un nom unique
          zip.file(`${data.path}`, output);

          // Enregistrement du succès
          results.push({ id, status: "success" });
        } catch (error) {
          console.error(`Error processing ID: ${id}`, error);
          // Enregistrement de l'échec
          results.push({ id, status: "error", message: error.message });
        }
      }

      // Génération du fichier ZIP et téléchargement s'il y a des fichiers réussis
      if (results.some((result) => result.status === "success")) {
        const zipBlob = await zip.generateAsync({ type: "blob" });
        FileSaver.saveAs(zipBlob, `attestations-session-${sessionId}.zip`);
      }

      console.clear();
    } catch (error) {
      console.error("Error during the batch download process:", error);
      results.push({ globalStatus: "error", message: error.message });
    }

    return results;
  }

  async handleDowloadAttendanceList(id, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dpc-attendance/download`;
    const token = accessToken;
    await fetch(url, {
      method: "POST",
      body: JSON.stringify({ sessionID: id }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        try {
          const binaryString = atob(data.file);

          // Conversion Base64 en octets (ArrayBuffer)
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          // Lecture du classeur Excel à partir des octets
          const workbook = read(bytes, { type: "array" });

          // Sélection de la première feuille du classeur (index 0)
          const sheetIndex = 0;
          const sheetName = workbook.SheetNames[sheetIndex];
          const worksheet = workbook.Sheets[sheetName];

          // Conversion de la feuille en JSON (optionnel)
          const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

          // Création d'un nouveau classeur Excel pour téléchargement
          const newWorkbook = utils.book_new();
          const newWorksheet = utils.aoa_to_sheet(jsonData);
          utils.book_append_sheet(newWorkbook, newWorksheet, "Feuille1");

          // Création d'un objet Blob contenant le nouveau classeur Excel
          const blob = new Blob(
            [write(newWorkbook, { bookType: "xlsx", type: "array" })],
            {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          );

          // Création d'un objet URL pour le Blob
          const url = URL.createObjectURL(blob);

          // Création d'un lien de téléchargement
          const link = document.createElement("a");
          link.href = url;
          link.download = "Emargements.xlsx";
          link.textContent = "Télécharger le fichier Excel";

          // Ajout du lien de téléchargement à la page et déclenchement du téléchargement
          document.body.appendChild(link);
          link.click();

          // Nettoyage de l'objet URL
          URL.revokeObjectURL(url);

          console.clear();
          return data;
        } catch (error) {
          const e = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            properties: error.properties,
          };
          console.log(JSON.stringify({ error: e }));
          // Gestion des erreurs ici
          throw error;
        }
      })
      .catch((error) => console.error(error));
  }

  async handleDownloadAttendanceListPdf(id, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dpc-attendance/download-pdf`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ sessionID: id }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();
    if (!data || !data.file) {
      throw new Error(
        data && data.message ? data.message : "Erreur lors de la génération du PDF",
      );
    }

    // Décodage du PDF (base64) → Blob → téléchargement
    const binaryString = atob(data.file);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: "application/pdf" });
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = data.path || "Liste-de-presence.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);

    return data;
  }

  async revomeGeneratedFile(name, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/agreements/remove?name=`;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    };
    await fetch(url + name, { headers })
      .then((response) => console.log(response))
      .catch((error) => console.error(error));
  }

  async sendDeathCertificate(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/send-death-certificate`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ learnerSessionId: id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await resp.json();
  }

  async sendCertificate(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/send`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ learnerSessionId: id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    console.clear();
    return json;
  }

  async sendSwarnStatement(id, accessToken, engine) {
    const URL = `${process.env.REACT_APP_API_URL}/api/swarn-statements/build`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ learnerSessionId: id, engine }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    console.clear();
    return json;
  }

  async sendMultipleSwarnStatements(selectedIds, accessToken, engine) {
    const token = "@B59y-4_L92@7ru";
    const URL = `${process.env.REACT_APP_API_URL}/api/sessions/send-bulk-swarn-statements`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ selectedIds, token, engine }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    console.clear();
    return json;
  }

  async sendMultipleAgreements(selectedIds, accessToken, engine) {
    const token = "@B59y-4_L92@7ru";
    const URL = `${process.env.REACT_APP_API_URL}/api/sessions/send-bulk-conventions`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ selectedIds, token, engine }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    console.clear();
    return json;
  }

  async sendMultipleCertificates(ids, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/send`;
    const results = [];

    try {
      for (const id of ids) {
        try {
          const resp = await fetch(URL, {
            method: "POST",
            body: JSON.stringify({ learnerSessionId: id }),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          });

          if (!resp.ok) {
            throw new Error(`Failed to send certificate request for ID: ${id}`);
          }

          const json = await resp.json();
          results.push({ id, status: "success", response: json });
        } catch (error) {
          // console.error(`Error processing ID: ${id}`, error);
          results.push({ id, status: "error", message: error.message });
        }
      }

      console.clear();
    } catch (error) {
      // console.error("Error during the batch request process:", error);
      results.push({ globalStatus: "error", message: error.message });
    }

    return results;
  }

  async sendFifplCertificate(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/fifpl-certificate/send`;
    const resp = await fetch(URL, {
      method: "POST",
      body: JSON.stringify({ learnerSessionId: id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    console.clear();
    return json;
  }

  /**
   * Télécharge les attestations FIF-PL, sans rien envoyer.
   *
   * Un seul apprenant donne un PDF ; plusieurs donnent une archive. Zipper un
   * fichier unique obligerait à le dézipper pour rien — c'est le cas courant,
   * une session ne comptant souvent qu'un apprenant en FIFPL-PAIEMENT.
   *
   * Rend un bilan plutôt qu'un tableau de réponses : l'écran a besoin de
   * distinguer « tout est passé » de « trois sur cinq », et de montrer le
   * motif du refus, qui nomme les champs manquants.
   */
  async downloadMultipleFifplCertificates(ids, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/fifpl-certificate/download`;
    const fichiers = [];
    const erreurs = [];

    for (const id of ids) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const response = await fetch(url, {
          method: "POST",
          body: JSON.stringify({ learnerSessionId: id }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        // eslint-disable-next-line no-await-in-loop
        const data = await response.json();

        if (!response.ok || !data.file) {
          erreurs.push(data.errorMessage || data.message || `Apprenant ${id}`);
          // eslint-disable-next-line no-continue
          continue;
        }

        const binaire = atob(data.file);
        const octets = new Uint8Array(binaire.length);
        for (let i = 0; i < binaire.length; i++) octets[i] = binaire.charCodeAt(i);

        fichiers.push({ nom: data.path || `Attestation_FIFPL_${id}.pdf`, octets });
      } catch (error) {
        console.error(`Attestation FIF-PL, apprenant ${id} :`, error);
        erreurs.push(`Apprenant ${id} : le téléchargement a échoué.`);
      }
    }

    if (fichiers.length === 1) {
      FileSaver.saveAs(
        new Blob([fichiers[0].octets], { type: "application/pdf" }),
        fichiers[0].nom
      );
    } else if (fichiers.length > 1) {
      const zip = new JSZip();
      fichiers.forEach((f) => zip.file(f.nom, f.octets));
      const contenu = await zip.generateAsync({ type: "blob" });
      FileSaver.saveAs(contenu, "attestations-fifpl.zip");
    }

    return { telecharges: fichiers.length, erreurs };
  }

  async sendMultipleFifplCertificates(ids, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/fifpl-certificate/send`;
    const results = [];
    for (const id of ids) {
      try {
        const resp = await fetch(URL, {
          method: "POST",
          body: JSON.stringify({ learnerSessionId: id }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const json = await resp.json();
        results.push({
          id,
          status: resp.ok ? "success" : "error",
          response: json,
        });
      } catch (error) {
        results.push({ id, status: "error", message: error.message });
      }
    }

    console.clear();
    return results;
  }

  async downloadCertificateToPdf(id, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/download-pdf`;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ learnerSessionId: id }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download PDF for ID: ${id}`);
      }

      const data = await response.json();
      const binaryString = atob(data.file);

      // Conversion Base64 en octets (ArrayBuffer)
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Création d'un objet Blob pour le PDF
      const blob = new Blob([bytes], { type: "application/pdf" });

      // Utilisation de FileSaver.js pour télécharger le fichier
      FileSaver.saveAs(blob, `${data.path.slice(0, -5)}.pdf`);

      console.clear();
      return { id, status: "success" };
    } catch (error) {
      console.error(`Error processing ID: ${id}`, error);
      return { id, status: "error", message: error.message };
    }
  }

  async downloadMultipleCertificatesToPdf(ids, sessionId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dpc-certificate/download-pdf`;
    const zip = new JSZip();
    const results = [];

    try {
      for (const id of ids) {
        try {
          const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({ learnerSessionId: id }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Failed to download PDF for ID: ${id}`);
          }

          const data = await response.json();
          const binaryString = atob(data.file);

          // Conversion Base64 en octets (ArrayBuffer)
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          // Ajout du fichier PDF au ZIP avec un nom unique
          zip.file(`${data.path.slice(0, -5)}.pdf`, bytes);

          // Enregistrement du succès
          results.push({ id, status: "success" });
        } catch (error) {
          console.error(`Error processing ID: ${id}`, error);
          // Enregistrement de l'échec
          results.push({ id, status: "error", message: error.message });
        }
      }

      // Génération du fichier ZIP et téléchargement s'il y a des fichiers réussis
      if (results.some((result) => result.status === "success")) {
        const zipBlob = await zip.generateAsync({ type: "blob" });
        FileSaver.saveAs(zipBlob, `certificats-session-${sessionId}.zip`);
      }

      console.clear();
    } catch (error) {
      console.error("Error during the batch download process:", error);
      results.push({ globalStatus: "error", message: error.message });
    }

    return results;
  }

  async sendWelcomeMail(idLearner, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/send-welcome-mail`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ customerId: idLearner }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const result = await response.json();
  }

  /** Inscriptions proposées à la confirmation, avec leur modèle de mail. */
  async getInscriptionConfirmationOptions(customerId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/${customerId}/inscription-confirmation`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await response.json();
  }

  /** Aperçu : un mail par format, déjà rendu tel qu'il partira. */
  async previewInscriptionConfirmation(customerId, lsIds, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/inscription-confirmation/preview`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ customerId, lsIds }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await response.json();
  }

  async sendInscriptionConfirmation(customerId, lsIds, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/inscription-confirmation/send`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ customerId, lsIds }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await response.json();
  }

  async checkAndCall(phoneNumber, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/call`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ phone: phoneNumber }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const result = await response.json();
  }

  async fetchCallDetails(callId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/fetch-call-details`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ callId }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const result = await response.json();

    return result;
  }

  async getByRPPS(accessToken, rpps) {
    const urlCustomers = `${process.env.REACT_APP_API_URL}/api/customers/get-by-rpps`;
    const values = {};
    values.rpps = rpps;
    const resp = await fetch(urlCustomers, {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getDistinctProfessionsFromLearnerSession(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/customers/distinct-professions`;

    const resp = await fetch(urlProfessions, {
      method: "POST",
      body: JSON.stringify({}),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async exportCustomers(accessToken, exportType = "apprenants") {
    const urlExport = `${process.env.REACT_APP_API_URL}/api/customers/export`;
    const resp = await fetch(urlExport, {
      method: "POST",
      body: JSON.stringify({ exportType }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (resp.ok) {
      const csvData = await resp.text();
      return {
        status: 200,
        data: csvData,
      };
    } else {
      const error = await resp.json();
      return {
        status: resp.status,
        error: error.message || "Erreur lors de l'export",
      };
    }
  }

  async exportCustomersByImport(accessToken, importId) {
    const urlExport = `${process.env.REACT_APP_API_URL}/api/customers/export-by-import`;
    const resp = await fetch(urlExport, {
      method: "POST",
      body: JSON.stringify({ import_id: importId }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (resp.ok) {
      const csvData = await resp.text();
      return {
        status: 200,
        data: csvData,
        filename: `export_import_${importId}_${new Date().toISOString().split("T")[0]}.csv`,
      };
    } else {
      const error = await resp.json();
      return {
        status: resp.status,
        error: error.message || "Erreur lors de l'export par import",
      };
    }
  }
}

export const customerApi = new CustomerApi();
